import PortalIdParser from 'PortalIdParser';
import { SEGMENT_TYPES } from 'personalization-lib/constants/segments';
export const getSegmentCreateUrl = segmentType => {
  switch (segmentType) {
    case SEGMENT_TYPES.WEB_VISITOR:
      return `/contacts/${PortalIdParser.get()}/webVisitors/create`;
    case SEGMENT_TYPES.OBJECT_LIST:
      return `/contacts/${PortalIdParser.get()}/objectLists/create?objectTypeId=0-1`;
    default:
      return '';
  }
};
export const getSegmentDetailsUrl = segment => {
  const {
    segmentType,
    implementationObjectId
  } = segment;
  switch (segmentType) {
    case SEGMENT_TYPES.WEB_VISITOR:
      return `/contacts/${PortalIdParser.get()}/web-visitors/${implementationObjectId}`;
    case SEGMENT_TYPES.OBJECT_LIST:
      return `/contacts/${PortalIdParser.get()}/objectLists/segment/${implementationObjectId}`;
    default:
      return '';
  }
};